import * as Yup from 'yup'

export const ReferencesValidationSchema = Yup.object().shape({
  personal: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Se requiere el nombre de la persona'),
      phone: Yup.string().required('Se requiere el número del telefono')
    }),
  ).min(2, 'Se requiere al menos duas referencia personal'),
  professional: Yup.array().of(
    Yup.object().shape({
      company: Yup.string().required('Se requiere el nombre de la empresa'),
      name: Yup.string().required('Se requiere el nombre del contacto'),
      phone: Yup.string().required('Se requiere el número del telefono')
    }),
  ).min(2, 'Se requiere al menos duas referencia personal'),
})
